import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery, put } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import {
  EXPORT_PARTICIPATION_ACTIVITY_FAILURE,
  EXPORT_PARTICIPATION_ACTIVITY_SUCCESS,
} from './actions'

export function* exportParticipationActivity() {
  yield takeEvery(
    EXPORT_PARTICIPATION_ACTIVITY_SUCCESS,
    function* (action: IFileDownloadResponse & Action) {
      try {
        yield download(action.data, action.data.name)
      } catch (error: unknown) {
        yield put({ type: EXPORT_PARTICIPATION_ACTIVITY_FAILURE, error })
      }
    },
  )
}
